// Centralised WhatsApp URL helper.
// Using web.whatsapp.com/send on desktop avoids the api.whatsapp.com
// intermediate redirect, which is often blocked by ad-blockers, corporate
// filters or ISP DNS. The whatsapp:// scheme deep-links straight into the
// native app on mobile.

export const WHATSAPP_NUMBER = "918891516363";
export const WHATSAPP_DISPLAY = "+91 88915 16363";

const isMobileUA = () =>
  typeof navigator !== "undefined" &&
  /iPhone|iPad|iPod|Android|Mobile/i.test(navigator.userAgent || "");

export function buildWhatsAppUrl(message = "") {
  const text = message ? encodeURIComponent(message) : "";
  if (isMobileUA()) {
    return `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${text}` : ""}`;
  }
  return `https://web.whatsapp.com/send?phone=${WHATSAPP_NUMBER}${text ? `&text=${text}` : ""}`;
}
